import React, {useRef, useState} from "react";
import RestRequest from "../../tool/RestRequest";
import Loader from "../Loader/Loader";
import config from "../../config";
import {BasketCounter} from "../../service/BasketCounter";
import CounterControl from "./CounterControls";

export default function AddToBasketButton({product_id, isExist = false, params = {}}) {

    const [progress, setProgress] = useState(false);
    const [inBasket, setInBasket] = useState(isExist);
    const [counter, setCounter] = useState(params.defaultCount);
    // const form = useRef();

    let add2Basket = (event) => {
        event.preventDefault();

        let params = new FormData();
        params.append('product_id', product_id);
        setProgress(!progress);

        RestRequest.post(config.restBasket, {
            body: params
        }).then(data => {

            if (data.status === 200) {

                updateCounter(true);

                setInBasket(!inBasket);
                setProgress(false);
                setCounter(1);
            }
        });

    };

    let updateCounter = (hasAdd = false) => {
        BasketCounter.update(hasAdd);
    };


    if (progress) {
        return <div className="basket-button">
            <Loader/>
        </div>
    } else {
        if (inBasket) {
            return <>

                <div className="basket-control-container">
                    <div className={`btn-main in-basket basket-button`}>
                        <div className="basket-button-label">В корзине</div>
                        <a className="basket-button-link" href={params.url}>Перейти</a>
                    </div>

                    <CounterControl
                        product_id={product_id}
                        params={{
                            setCounter: setCounter,
                            setInBasket: setInBasket,
                            updateCounter: updateCounter,
                        }}
                        count={counter}/>
                </div>
            </>
        } else {
            return <button onClick={add2Basket.bind(this)} className="btn-main basket-button">В корзину</button>
        }
    }
}